import React from 'react';

import FrontTextsScreen from './FrontTextsScreen';

export default (props: any) => <FrontTextsScreen {...props} />;
